export const BASE_URL = process.env.REACT_APP_BASE_URL;

export const API = {
  adminLogin: "/admin/login",
  getUsers: "/admin/users",
};
